import { useLanguage } from "@/contexts/LanguageContext";
import { Button, Box } from "@mui/material";

const LanguageToggle = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexDirection: "row",
            width: "100%",
            padding: "16px",
        }}>
            <Button
                variant={language === "id" ? "contained" : "outlined"}
                onClick={() => setLanguage("id")}
                sx={{ mr: 1 }}
            >
                ID
            </Button>
            <Button
                variant={language === "en" ? "contained" : "outlined"}
                onClick={() => setLanguage("en")}
            >
                EN
            </Button>
        </Box>
    );
};

export default LanguageToggle;
